import azureSearch from '@frontisbv/scheffer-azuresearch-searchclient';
import Vue from 'vue';
import qs from 'querystring';

function init(elId) {
    new Vue({
        el: '#' + elId,
        data() {
            return {
                btnNormalConditionsCssClass: 'btn-primary',
                btnHeavyConditionsCssClass: 'btn-primary',
                customTableData: [],
                products: [],
                productSKUs: [],
                searchApi: null,
                searchSettings: {},
                selectedCondition: '',
                selectedMaterial: '',
                selectedMaterialType: '',
                activeSteps: [true, false],
                market: ''
            };
        },
        computed: {
            materials() {
                const array = [];
                for (let i = 0; i < this.customTableData.length; i++) {
                    const setting = this.customTableData[i];
                    if (setting.materialType === this.selectedMaterialType) {
                        let includes = this.containsValue(array, setting.material);
                        if (!includes) {
                            array.push({
                                key: setting.material,
                                value: setting.materialDisplayName
                            });
                        }
                    }
                }
                return array;
            },
            materialTypes() {
                const array = [];
                for (let i = 0; i < this.customTableData.length; i++) {
                    const setting = this.customTableData[i];
                    let includes = this.containsValue(array, setting.materialType);
                    if (!includes) {
                        array.push({
                            key: setting.materialType,
                            value: setting.materialTypeDisplayName
                        });
                    }
                }
                return array;
            },
            showResult() {
                if (this.activeSteps[1]) {
                    return this.containsValue(this.materials, this.selectedMaterial) && this.selectedCondition !== '';
                } else {
                    return this.containsValue(this.materials, this.selectedMaterial);
                }
            },
            conctactFormQueryString() {
                const queryParams = {};
                if (this.selectedMaterialType) queryParams['materialType'] = this.selectedMaterialType;
                if (this.selectedMaterial) queryParams['material'] = this.selectedMaterial;
                if (this.selectedCondition) queryParams['condition'] = this.selectedCondition;
                if (this.market) queryParams['market'] = this.market;
                if (this.products && this.products.length > 0) queryParams['products'] = this.products.map(x => x.name);
                return '?' + qs.stringify(queryParams);
            },
            hasRecommendedProduct() {
                return this.productSKUs.some(x => x.recommended);
            },
            // products are sorted as follows:
            // - products are ordered by skunumber
            // - recommended products are always displayed first
            sortedProducts() {
                return this.products
                    .sort((a, b) => {
                        if (this.isRecommendedProduct(a) && !this.isRecommendedProduct(b)) return -1;
                        if (!this.isRecommendedProduct(a) && this.isRecommendedProduct(b)) return 1;
                        return a.skunumber - b.skunumber;
                    });
            }
        },
        methods: {
            conditionClicked(condition) {
                this.selectedCondition = condition;

                if (condition === 'normalConditionBonding') {
                    this.btnNormalConditionsCssClass = 'btn-secondary';
                    this.btnHeavyConditionsCssClass = 'btn-primary';
                } else if (condition === 'heavyConditionBonding') {
                    this.btnNormalConditionsCssClass = 'btn-primary';
                    this.btnHeavyConditionsCssClass = 'btn-secondary';
                } else {
                    this.btnNormalConditionsCssClass = 'btn-primary';
                    this.btnHeavyConditionsCssClass = 'btn-primary';
                }
            },
            containsValue(array, value) {
                let includes = false;
                for (let j = 0; j < array.length; j++) {
                    if (array[j].key === value) {
                        includes = true;
                    }
                }
                return includes;
            },
            createSearchRequest() {
                const searchRequest = new azureSearch.AzureSearchRequest(this.searchSettings.searchRequest);
                const predefinedFilters = this.searchSettings.searchRequest.filter;
                const skuFilter = createFilterForSKUs(this.productSKUs);
                searchRequest.filter = ConcatFilters([predefinedFilters, skuFilter]);
                return searchRequest;
            },
            executeSearch(searchRequest) {
                const self = this;

                return new Promise((resolve, reject) => {
                    self.searchApi.search(searchRequest)
                        .then((res) => {
                            if (res && res.data) {
                                resolve(res.data);
                            } else resolve('EMPTY_RESPONSE');
                        })
                        .catch(reject);
                });
            },
            filterProductSKUs() {
                if (this.containsValue(this.materials, this.selectedMaterial) && this.containsValue(this.materialTypes, this.selectedMaterialType)) {
                    for (let i = 0; i < this.customTableData.length; i++) {
                        const setting = this.customTableData[i];
                        if (setting.materialType === this.selectedMaterialType && setting.material === this.selectedMaterial) {
                            const selectedCondition = this.selectedCondition || 'normalConditionBonding';
                            this.productSKUs = setting[selectedCondition]
                                .split('\r\n')
                                .map(x => {
                                    const props = x.split('|');
                                    return {
                                        skunumber: props[0],
                                        sanding: props.some(x => x === 'schuren'),
                                        recommended: props.some(x => x === 'advies')
                                    };
                                });
                            break;
                        }
                    }
                }
            },
            getDocumentUrl(item) {
                const documentCulture = item.documentculture.toLowerCase() === 'en-zw' || item.documentculture.toLowerCase() === 'es-ve'
                    ? item.documentculture.split('-')[0]
                    : item.documentculture;
                if (item.documenturlpath) return `/${documentCulture}${item.documenturlpath}/`.toLowerCase();
                return '';
            },
            getTeaserImage(teaserimage) {
                if (teaserimage) return teaserimage.replace('~', '');
                else return '/Images/no_image.svg';
            },
            getValueInArray(array, key) {
                for (let j = 0; j < array.length; j++) {
                    if (array[j].key === key) {
                        return array[j].value;
                    }
                }
            },
            isRecommendedProduct(product) {
                for (let i = 0; i < this.productSKUs.length; i++) {
                    if (this.productSKUs[i].skunumber === product.skunumber) {
                        return this.productSKUs[i].recommended;
                    }
                }
                return false;
            },
            search() {
                const self = this;

                return new Promise((resolve, reject) => {
                    const searchRequest = self.createSearchRequest();
                    self.executeSearch(searchRequest)
                        .then((data) => {
                            if (data && data.value) {
                                self.products = data.value;
                                resolve(data);
                            }
                        })
                        .catch(reject);
                });
            },
            shouldBeSanded(product) {
                for (let i = 0; i < this.productSKUs.length; i++) {
                    if (this.productSKUs[i].skunumber === product.skunumber) {
                        return this.productSKUs[i].sanding;
                    }
                }
                return false;
            }
        },
        watch: {
            productSKUs() {
                this.search()
                    .then(() => {})
                    .catch(console.error);
            },
            selectedCondition() {
                this.filterProductSKUs();
            },
            selectedMaterial() {
                this.filterProductSKUs();
            },
            selectedMaterialType() {
                this.filterProductSKUs();
            }
        },
        mounted() {
            const searchSettingsEl = document.getElementById('searchSettings');
            if (searchSettingsEl) this.searchSettings = JSON.parse(searchSettingsEl.innerHTML);

            const configuratorSettingsEl = document.getElementById('configuratorSettings');
            if (configuratorSettingsEl) {
                const configuratorSettings = JSON.parse(configuratorSettingsEl.innerHTML);
                this.activeSteps = configuratorSettings.activeSteps;
                this.customTableData = configuratorSettings.customTableData;
                this.market = configuratorSettings.market;
            }

            if (this.customTableData && this.customTableData.length > 0 && this.searchSettings) {
                if (!this.searchSettings.searchRequest.orderBy) this.searchSettings.searchRequest.orderBy = 'name asc';
                this.searchApi = new azureSearch.AzureSearchApi(this.searchSettings);
            } else {
                console.error('Missing mandatory settings for customTableData or searchSettings!');
            }
        }
    });
}

function ConcatFilters(filterArgs) {
    if (filterArgs) {
        let filters;
        for (let i = 0; i < filterArgs.length; i++) {
            if (filterArgs[i] && filterArgs[i] !== '') {
                if (filters) {
                    filters = (filters + ' and ' + filterArgs[i]);
                } else {
                    filters = filterArgs[i];
                }
            }
        }
        return filters;
    }
    return null;
}

function createFilterForSKUs(skus) {
    if (skus) {
        let filters;
        for (let i = 0; i < skus.length; i++) {
            if (skus[i] && skus[i] !== '') {
                if (filters) {
                    filters = `${filters} or (skunumber eq '${skus[i].skunumber}')`;
                } else {
                    filters = `(skunumber eq '${skus[i].skunumber}')`;
                }
            }
        }
        return `(${filters})`;
    }
    return null;
}

export default {
    init
};
